import React from 'react';
import { TagIcon } from 'lucide-react';
import MerchCategoryPage, { MerchProduct } from '../../components/Merch/MerchCategoryPage';
const clothingProducts: MerchProduct[] = [{
  id: 'c1',
  name: 'Bookish & Brave Hoodie',
  vendorName: 'LiteraryThreads',
  vendorSlug: 'literary-threads',
  vendorImage: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 45.0,
  rating: 4.8,
  reviewCount: 124,
  subcategory: 'Hoodies',
  tags: ['cozy', 'cotton', 'unisex'],
  description: 'Premium heavyweight hoodie featuring "Bookish & Brave" typography. Perfect for cozy reading sessions.',
  shipping: 'Worldwide',
  location: 'Seattle, WA'
}, {
  id: 'c2',
  name: 'Fantasy Map Leggings',
  vendorName: 'WhimsyReads',
  vendorSlug: 'whimsy-reads',
  vendorImage: 'https://images.unsplash.com/photo-1586892477838-2b96e85e0f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 32.0,
  rating: 4.6,
  reviewCount: 89,
  subcategory: 'Leggings',
  tags: ['fantasy', 'map', 'activewear'],
  description: 'Full-print leggings featuring a vintage-style fantasy world map. Soft, stretchy, and durable.',
  shipping: 'Worldwide',
  location: 'Portland, OR'
}, {
  id: 'c3',
  name: 'Classic Literature Tee',
  vendorName: 'PageTurnerTotes',
  vendorSlug: 'page-turner-totes',
  vendorImage: 'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 24.0,
  rating: 4.9,
  reviewCount: 210,
  subcategory: 'T-Shirts',
  tags: ['classic', 'cotton', 'vintage'],
  description: 'Soft cotton t-shirt with a minimalist stack of classic books design.',
  shipping: 'Worldwide',
  location: 'Austin, TX'
}, {
  id: 'c4',
  name: 'Dark Academia Sweater',
  vendorName: 'DarkAndDisturbed',
  vendorSlug: 'dark-and-disturbed',
  vendorImage: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1620799140408-ed5341cd2431?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 55.0,
  rating: 4.7,
  reviewCount: 65,
  subcategory: 'Sweatshirts',
  tags: ['dark academia', 'knit', 'autumn'],
  description: 'Chunky knit sweater in deep forest green, perfect for the dark academia aesthetic.',
  shipping: 'US & Canada',
  location: 'Salem, MA'
}, {
  id: 'c5',
  name: 'Reading is Magic Pajama Set',
  vendorName: 'BookishTreasuresSydney',
  vendorSlug: 'bookish-treasures-sydney',
  vendorImage: 'https://images.unsplash.com/photo-1526280760714-f9e8b26f318f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 48.0,
  rating: 4.8,
  reviewCount: 42,
  subcategory: 'Pajamas',
  tags: ['sleepwear', 'satin', 'luxury'],
  description: 'Silky satin pajama set with star and book constellations print.',
  shipping: 'Worldwide',
  location: 'Sydney, Australia'
}, {
  id: 'c6',
  name: 'Library Card Scarf',
  vendorName: 'LondonBookLovers',
  vendorSlug: 'london-book-lovers',
  vendorImage: 'https://images.unsplash.com/photo-1571331627305-b3c24197a15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1520903920243-00d872a2d1c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 28.0,
  rating: 4.9,
  reviewCount: 156,
  subcategory: 'Accessories',
  tags: ['winter', 'scarf', 'library'],
  description: 'Infinity scarf printed with vintage library checkout cards.',
  shipping: 'Worldwide',
  location: 'London, UK'
}, {
  id: 'c7',
  name: 'Dragon Scale Socks',
  vendorName: 'FantasyRealmCrate',
  vendorSlug: 'fantasy-realm-crate',
  vendorImage: 'https://images.unsplash.com/photo-1578950435899-d1c1bf932b1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1586350977771-b3b0abd50c82?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 14.0,
  rating: 4.5,
  reviewCount: 300,
  subcategory: 'Socks',
  tags: ['fantasy', 'dragons', 'fun'],
  description: 'Knee-high socks with a shimmering dragon scale pattern.',
  shipping: 'Worldwide',
  location: 'Denver, CO'
}, {
  id: 'c8',
  name: 'Book Nerd Beanie',
  vendorName: 'TorontoBookishGoods',
  vendorSlug: 'toronto-bookish-goods',
  vendorImage: 'https://images.unsplash.com/photo-1544816155-12df9643f363?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1576871337632-b9aef4c17ab9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 22.0,
  rating: 4.7,
  reviewCount: 98,
  subcategory: 'Hats',
  tags: ['winter', 'beanie', 'embroidered'],
  description: 'Cozy knit beanie with "Book Nerd" embroidered on the cuff.',
  shipping: 'North America',
  location: 'Toronto, Canada'
}];
const Clothing = () => {
  return <MerchCategoryPage title="Bookish Clothing" description="Wear your love for books on your sleeve (literally). Discover t-shirts, hoodies, and apparel inspired by your favorite stories." icon={<TagIcon className="h-5 w-5" data-id="element-9757" data-mp="n4tdfdo8vwyz" />} products={clothingProducts} filterOptions={{
    subcategories: ['T-Shirts', 'Hoodies', 'Sweatshirts', 'Leggings', 'Pajamas', 'Socks', 'Hats'],
    priceRanges: [{
      label: 'Under $25',
      min: 0,
      max: 25
    }, {
      label: '$25 - $50',
      min: 25,
      max: 50
    }, {
      label: '$50+',
      min: 50,
      max: null
    }],
    vendors: Array.from(new Set(clothingProducts.map(p => p.vendorName))).sort()
  }} data-id="element-9756" data-mp="2hikmoc2nwetw" />;
};
export default Clothing;